import { HeadingText, small } from '@unmind/design-system-components-web';
import { ThemeInterface } from 'styles/lightTheme';
import styled, { css } from 'styled-components';
import { rem } from 'polished';

const SectionHeadingTitleAttrs = ({ theme }: { theme: ThemeInterface }) => ({
  level: 2,
  color: theme.colors.text.primary,
  sizes: [theme.typography.fontSizes.fontSize18],
  weight: theme.typography.fontWeights.semiBold,
});

export const SectionHeadingTitleStyle = css`
  &:focus {
    outline: none;
  }

  ${small(css`
    line-height: 1.3;
  `)}
`;

export const SectionHeadingTitle = styled(HeadingText).attrs(
  SectionHeadingTitleAttrs,
)`
  ${SectionHeadingTitleStyle}
  margin-bottom: ${rem(20)};
`;
